<template>
    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner />
    </b-container>
    <div v-else>

       <custom-table-list :options="filters"
                          :fields="fields"
                          placeholder-search="Поиск фильтров"
                          edit-link="/Admin/Bot/Filters/Edit" />

    </div>
</template>
<script>
import apiService from '@/services/api.service'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

import CustomTableList from '@/components/shared/CustomTableList'

export default {
    data: function() {
        let load = new Loading();
        this.getAll(load);
        return {
            load: load,

            filters: null,
            fields: [
                { 
                    key: 'BotFormId', 
                    label: 'ID',
                    sortable: true
                },
                {
                    key: 'BotFormName', 
                    label: 'Название', 
                    sortable: true
                }
            ]
                   
        }
    },
    methods: {
        getAll: function(load) {
            load.Calculate(true);

            apiService.Admin.Bot.Filters.GetAll()
                .then(response => {
                    this.filters = response.data;
                    load.Calculate(false);
                })
                .catch(() => load.Calculate(false));
        }
    },
    components: {
        Spinner,
        CustomTableList
    }
}
</script>
